module.exports = __webpack_public_path__ + "media/images/icon__checkmark@2x-ef31c5cdc1a7633f9e9b1dd9e588d528.png";